/**
 * 获取列表界面的搜索项
 */
export function getSearchData(flag) {
    let data = []
    switch (flag) {
        case "workLicense":
            // 上岗证考核任务列表
            data = [{
                    title: "任务主题",
                    type: "input",
                    value: "",
                    key: "name",
                },
                {
                    title: "专业",
                    type: "select",
                    value: "",
                    key: "professional",
                    options: []
                },
            ]
            break;
        case "workLicenseSetting":
            // 上岗证设置
            data = [{
                title: "名称",
                type: "input",
                value: "",
                key: "name",
            }, ]
            break
        case "workLicenseManageUserList":
            // 上岗证考核任务列表
            data = [{
                title: "学员",
                type: "select",
                value: "",
                key: "uId",
                options: []
            }, {
                title: "专业",
                type: "select",
                value: "",
                key: "professionalId",
                options: []
            }, {
                title: "工种/岗位",
                type: "select",
                value: "",
                key: "stationId",
                options: []
            }, ]
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取界面搜索框旁边的按钮
 * @param {*} flag  标识哪个界面
 */
export function getTopButArray(flag) {
    let data = []
    switch (flag) {
        case "workLicense":
            // 上岗证考核任务列表
            data = [
                { name: "新增考核", active: "create", icon: "el-icon-plus" },
            ]
            break;
        case "workLicenseStationSetting":
            // 上岗证工种/岗位列表
            data = [
                { name: "新增工种/岗位", active: "create_station", icon: "el-icon-plus" },
            ]
            break;
        case "workLicenseExamOpinionSetting2":
            // 上岗证工种/岗位列表
            data = [
                { name: "新增考核意见", active: "create_station", icon: "el-icon-plus" },
            ]
            break;
        case "workLicenseDeductionSetting":
            // 上岗证列表
            data = [
                { name: "新增扣分项", active: "create_deduction", icon: "el-icon-plus" },
            ]
            break;
        case "workLicenseUser":
            // 查看当前上岗证的所有用户
            data = [
                { name: "上岗证生成", active: "workLicense", icon: "el-icon-postcard" },
                { name: "考核归档", active: "end", icon: "el-icon-wallet" },
                { name: "实操成绩导入", active: "import", icon: "el-icon-download" },
            ]
            break

        default:
            break;
    }
    return data
}
/**
 * 获取上岗证考核列表的表头数据
 */
export function getTableMenu(flag) {
    let data = []
    switch (flag) {
        case "workLicense":
            // 上岗证考核任务
            data = [
                { name: "考核主题", key: "name", isStar: false },
                { name: "专业", key: "professional", isStar: false },
                { name: "工种/岗位", key: "station", isStar: false },
                { name: "理论考试主题", key: "exam", isStar: false },
                { name: "考核状态", key: "status", isStar: false },
                { name: "理论占比", key: "examGrade", isStar: false },
                { name: "实操占比", key: "practicalGrade", isStar: false },
            ]
            break;
        case "workLicenseStationSetting":
            // 上岗证工种/岗位配置项设置
            data = [
                { name: "名称", key: "mean", isStar: false },
            ]
            break;
        case "workLicenseDeductionSetting":
            // 上岗证扣分项配置设置
            data = [
                { name: "描述", key: "name", isStar: false },
                // { name: "分值", key: "grade", isStar: false },
            ]
            break;
        case "workLicenseUser":
            // 查看当前上岗证的所有用户
            data = [
                { name: "学员姓名", key: "userName", isStar: false },
                { name: "理论成绩", key: "examGrade", isStar: false },
                { name: "实操成绩", key: "practicalGrade", isStar: false },
                { name: "总成绩", key: "grade", isStar: false },
                { name: "是否合格", key: "isPass", isStar: false },
            ]
            break
        case "workLicenseManageUserList":

            // 查看所有已获得当前上岗证的用户
            data = [
                { name: "学员姓名", key: "name", isStar: false },
                { name: "专业", key: "professional", isStar: false },
                { name: "上岗证编号", key: "number", isStar: false },
                { name: "工种/岗位", key: "station", isStar: false },
                { name: "发证日期", key: "time", isStar: false },
                { name: "剩余分数", key: "surplusGrade", isStar: false },
                { name: "上岗证状态", key: "status", isStar: false, isColor: true },
            ]
            break

        default:
            break;
    }
    return data
}

/**
 * 获取表格操作按钮
 * @param {*} flag  表示当前为哪个界面的
 */
export function getTableBUttonList(flag) {
    let data = []
    switch (flag) {
        case "workLicense":
            // 上岗证考核列表
            data = [
                { text: "发布", active: "issue" },
                { text: "查看", active: "show" },
                { text: "取消发布", active: "unissue" },
                { text: "编辑", active: "edit" },
                { text: "归档", active: "end" },
                { text: "删除", active: "delete" },
            ]
            break;
        case "workLicenseStationSetting":
            // 上岗证工种/岗位配置项设置
            data = [
                { text: "编辑", active: "edit_station" },
                { text: "删除", active: "delete" },
            ]
            break
        case "workLicenseDeductionSetting":
            // 上岗证扣分项配置项设置
            data = [
                { text: "编辑", active: "edit_deduction" },
                { text: "删除", active: "delete" },
            ]
            break
        case "workLicenseUser":
            // 查看当前上岗证的所有用户
            data = [
                { text: "实操成绩录入", active: "entering" }
            ]
            break
        case "workLicenseManageUserList":
            // 查看所有已获得当前上岗证的用户
            data = [
                { text: "查看", active: "show" },
                { text: "扣分", active: "deduct" },
                { text: "扣分记录", active: "record" },
            ]
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取上岗证添加的界面数据
 */
export function getEditData() {
    let list = [
        { title: "主题", key: "name", value: "", type: "input", style: "1", isNotNull: true },
        { title: "考核专业", key: "professionalId", value: "", type: "select", options: [], style: "2", isNotNull: true },
        { title: "工种/岗位", key: "station", value: "", type: "select", options: [], style: "2", isNotNull: true },
        { title: "理论考试", key: "examId", value: "", type: "select-disable", options: [], style: "1", isNotNull: true },
        { title: "理论占比", key: "examGrade", value: "", type: "input-num-precent", style: "2", isNotNull: true },
        { title: "实操占比", key: "practicalGrade", value: "", type: "input-num-precent", style: "2", isNotNull: true },
        { title: "合格占比", key: "passGrade", value: "", type: "input-num-precent", style: "2", isNotNull: true },
        { title: "", key: "", value: "", type: "", style: "2", isNotNull: false },
        { title: "考核总分", key: "totalScore", value: "", type: "input-num", style: "2", isNotNull: true },
        { title: "实操总分", key: "practicalScore", value: "", type: "input-num", style: "2", isNotNull: true },
    ]
    return list
}